import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Input, Typography, Sheet } from '@mui/joy';
import { supabase } from '../supabaseClient';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
    } else {
      navigate('/home');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        minHeight: '100vh',
        bgcolor: 'background.body',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 400,
          width: '100%',
          p: 4,
          borderRadius: 'md',
          boxShadow: 'md',
          mx: 'auto',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img
            src="/the_grid_logo.png"
            alt="The Grid Logo"
            style={{ maxWidth: '160px', marginBottom: '1rem', display: 'block', marginInline: 'auto' }}
          />
          <Typography level="h4">Login</Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="Email"
            fullWidth
            sx={{ mb: 2 }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            type="password"
            placeholder="Password"
            fullWidth
            sx={{ mb: 2 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <Typography color="danger" level="body-sm" sx={{ mb: 1 }}>
              {error}
            </Typography>
          )}
          <Button type="submit" fullWidth>
            Login
          </Button>
        </form>
        <Typography level="body-sm" sx={{ mt: 2 }}>
          If you are a client and reached this page by mistake, please visit{' '}
          <a href="http://clients.fldandp.com" target="_blank" rel="noopener noreferrer">
            http://clients.fldandp.com
          </a>
          .
        </Typography>
      </Sheet>
    </Box>
  );
}